import { chakra, Text, TextProps, ChakraComponent } from '@chakra-ui/react';

export const FinalPriceText = chakra(Text, {
  baseStyle: () => ({
    fontSize: 'sm',
  }),
}) as ChakraComponent<'p', TextProps>;
